module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00031.945c9dd2.png";